// extracted by mini-css-extract-plugin
module.exports = {"list":"row-item-setting-list_list__Ufn9t","date":"row-item-setting-list_date__3xppg","badge":"row-item-setting-list_badge__2bt9w"};